import React from 'react';
import { Fieldset, FormNumber } from '~/components/FormControl';
import { Form } from 'react-bootstrap';
import { formLabel } from '~/utils/helpers';

function PercentageChange() {
    return (
        <Fieldset className={'px-2'}>
            <Fieldset.Legend>{formLabel('PercentageChange')}</Fieldset.Legend>
            <Form.Row>
                <FormNumber
                    name="extraDailyQuestGranted"
                    sm={6}
                    inputGroupAppend={<PercentagePrepend />}
                />
                <FormNumber
                    name="extraRankEnergyGranted"
                    sm={6}
                    inputGroupAppend={<PercentagePrepend />}
                />
                <FormNumber
                    name="extraRankPointGained"
                    sm={6}
                    inputGroupAppend={<PercentagePrepend />}
                />
                <FormNumber
                    name="extraShopSlotGranted"
                    sm={6}
                    inputGroupAppend={<PercentagePrepend />}
                />
            </Form.Row>
        </Fieldset>
    );
}

export default PercentageChange;

function PercentagePrepend() {
    return (
        <div className="input-group-append">
            <span
                className="input-group-text"
                id="basic-addon1"
            >
                %
            </span>
        </div>
    );
}
